<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<TableFuncs>
				<QueryCondition @query="query" @exportExcel="exportExcel" ref="queryCondition" />
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition8'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import { LINK_TYPES } from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {
					appKey: '',
					startDate: null,
					endDate: null,
				},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '用户',
						key: 'name',
						align: 'center',
						width: 150,
					},{
						title: '应用市场渠道',
						key: 'storeChannel',
						align: 'center',
						width: 150,
					},
					{
						title: 'app渠道',
						align: 'center',
						width: 160,
						render:(h,params)=>{
							let name;
							let val=params.row.channel;
							if(val=='1'){
								name='新华万年历'
							}else if(val=='2'){
								name='吉日万年历'
							}else if(val=='3'){
								name='神农万年历'
							}else if(val=='4'){
								name='中华老黄历'
							}else if(val=='5'){
								name='九星万年历'
							}else if(val=='6'){
								name='东方万年历'
							}
							return h('span', name)
						}
					},
					{
						title: '充值金额',
						key: 'amount',
						align: 'center',
						width: 150,
					},{
						title: '充值类型',
						align: 'center',
						width: 150,
						render:(h,params)=>{
							let name;
							let val=params.row.businessType;
							if(val=='1'){
								name='一个月'
							}else if(val=='2'){
								name='半年'
							}else if(val=='3'){
								name='一年'
							}else if(val=='4'){
								name='终身'
							}else if(val=='5'){
								name='下载'
							}
							return h('span', name)
						}
					},{
						title: '充值时间',
						key: 'createTime',
						align: 'center',
						width: 200,
					},{
						title: '会员截止日期',
						align: 'center',
						width: 150,
						render:(h,params)=>{
							let name;
							let val=params.row.vipEndDate;
							if(val=='-1'){
								name='终身'
							}else{
								name=val
							}
							return h('span', name)
						}
					},
					
				]
			}
		},
		created() {
			//this.getData();
		},
		methods: {
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				if (!params.appKey) {
					this.$Message.warning('请选择app')
					return
				}			
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.member(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},

		},



	}
</script>
